module.exports = __webpack_public_path__ + "img/20230705165318.3c622295.png";